/* nomari SEO meta (preview batch 2026-10-03, v=20261003-1700; HK Nostalgia re-launch 2026-10-18, v=20261018-1400).
   Copy = copy/seo-meta-2026-10-18.json (2026-10-03 approved copy + new hk-nostalgia copy), verbatim. The DATA block below is rewritten by scripts/build-seo-pages.js;
   edit the JSON and re-run the script instead of editing it here.
   Runtime: NomariSEO.sync() sets document.title, meta description, og:title/description/url, twitter:title/description,
   <link rel=canonical> and hreflang alternates (zh-HK / en / x-default) for the view that is actually shown + current language.
   Pages without their own copy (checkout, done, info) keep the app title and use the home description. hk-nostalgia is visible again
   since 2026-10-18 (removed from HIDE in config.js), so ?p=hk-nostalgia uses its own copy. */
(function(){
  var ORIGIN = "https://jade-medley-6fmn.here.now/";
  /*SEO-DATA-START*/
  var DATA = {
   "home": {
    "zh": {
     "title": "溫哥華手作燈與禮物 | nomari studio",
     "description": "溫哥華手作小品牌，做 3D 打印小夜燈、小禮物同手工。網上預訂後會聯絡你，天車站交收或郵寄。",
     "og_title": "手作燈與小禮物",
     "og_description": "turn thoughts into gifts。網上預訂 3D 打印燈同手作小禮物，天車站交收或郵寄。"
    },
    "en": {
     "title": "Handmade Lights & Gifts, Vancouver | nomari studio",
     "description": "A Vancouver studio for 3D-printed lights, small gifts and handmade pieces. Pre-order online; we arrange SkyTrain pickup or shipping.",
     "og_title": "turn thoughts into gifts",
     "og_description": "3D-printed lights and handmade gifts from Vancouver. Pre-order online, then pick up or ship."
    }
   },
   "shop": {
    "zh": {
     "title": "全部產品目錄 | nomari studio",
     "description": "瀏覽可預訂作品：小夜燈、盲盒、隨身繡同鈎織。落單後會聯絡你，天車站交收或郵寄，交收前以 e-Transfer 付款。",
     "og_title": "預訂全部作品",
     "og_description": "小夜燈、盲盒、隨身繡同鈎織，網上揀好就預訂，之後再約交收。"
    },
    "en": {
     "title": "Shop the Pre-order Catalogue | nomari studio",
     "description": "Browse lights, blind boxes, Pocket Stitch and crochet. Pre-order online; we confirm SkyTrain pickup or shipping, paid by e-Transfer.",
     "og_title": "Pre-order catalogue",
     "og_description": "Lights, blind boxes, stitch and crochet. Choose your pieces and pre-order online."
    }
   },
   "custom": {
    "zh": {
     "title": "訂製燈箱與座 | nomari studio",
     "description": "訂製燈箱或座，例如舖頭櫃面放 logo 同 IG QR code。描述需要並網上提交，我們會聯絡你。",
     "og_title": "訂製燈箱同 logo 座",
     "og_description": "櫃面 logo、IG QR code 座或其他燈件，講低需要，網上提交即可。"
    },
    "en": {
     "title": "Custom Light Boxes & Stands | nomari studio",
     "description": "Custom light boxes and stands, such as a counter logo with an IG QR code. Describe what you need and send us an enquiry online.",
     "og_title": "Custom light box or stand",
     "og_description": "A counter logo, IG QR stand or other light piece. Send us an enquiry online."
    }
   },
   "sweet-light": {
    "zh": {
     "title": "竹筍朱古力燈 | nomari studio",
     "description": "竹筍朱古力造型小夜燈，三色光、可調光、USB 供電，5 色燈殼可揀換。可於網上預訂。",
     "og_title": "竹筍朱古力小夜燈",
     "og_description": "三色光、可調光、USB 供電，5 色燈殼可換。網上預訂 Bamboo Chocolate Light。"
    },
    "en": {
     "title": "Bamboo Chocolate Light | nomari studio",
     "description": "A bamboo-chocolate night light with 3 light colours, dimming and USB power. Choose from 5 shells. Pre-order online.",
     "og_title": "Bamboo Chocolate Light",
     "og_description": "Chocolate-shaped night light, 3 colours, dimmable, USB. Five shells to choose. Pre-order online."
    }
   },
   "apollo-light": {
    "zh": {
     "title": "士多啤梨 Apollo 燈 | nomari studio",
     "description": "雙色圓錐士多啤梨朱古力造型小夜燈，三色光、可調光、USB 供電。可於網上預訂。",
     "og_title": "士多啤梨 Apollo 小夜燈",
     "og_description": "雙色圓錐朱古力造型，三色光、可調光、USB 供電。網上預訂。"
    },
    "en": {
     "title": "Strawberry Apollo Light | nomari studio",
     "description": "A two-tone strawberry-chocolate cone night light. Three light colours, dimmable, USB powered. Pre-order online.",
     "og_title": "Strawberry Apollo Light",
     "og_description": "A two-tone chocolate cone night light. Three colours, dimmable, USB. Pre-order online."
    }
   },
   "panel-light": {
    "zh": {
     "title": "Nami Light 換面板 | nomari studio",
     "description": "基本套裝有 1 個燈芯（多色揀 1）同 4 塊圖案面板，圖案任揀、可自由更換。可於網上預訂。",
     "og_title": "Nami Light，換芯換面板",
     "og_description": "1 個燈芯加 4 塊圖案面板，圖案任揀，隨時換過個感覺。網上預訂。"
    },
    "en": {
     "title": "Nami Light, Swap Panels | nomari studio",
     "description": "Base set: 1 core (choose 1 colour) and 4 pattern panels. Pick any patterns and swap them freely. Pre-order online.",
     "og_title": "Nami Light, swap the panels",
     "og_description": "One colour core and four pattern panels. Change the panel, change the room. Pre-order online."
    }
   },
   "blind-box": {
    "zh": {
     "title": "老孖利士多盲盒 | nomari studio",
     "description": "香港士多主題盲盒，四款：什餅罐、西餅盒、啤酒箱、冰桶。可隨機或指定，網上預訂。",
     "og_title": "老孖利士多盲盒",
     "og_description": "什餅罐、西餅盒、啤酒箱、冰桶。隨機開盒，或指定款式，網上預訂。"
    },
    "en": {
     "title": "Nomari Store Blind Box | nomari studio",
     "description": "Four Hong Kong tuck-shop sets: biscuit tin, bakery box, beer crate and cooler. Random or chosen. Pre-order online.",
     "og_title": "Nomari Store Blind Box",
     "og_description": "Biscuit tin, bakery box, beer crate, cooler. Open at random, or choose your set."
    }
   },
   "clicker": {
    "zh": {
     "title": "動物 Clicker 市集 | nomari studio",
     "description": "自組動物 Clicker，揀底座尺寸、角色同顏色，可加字母珠。暫時只限市集，未開放網上預訂。",
     "og_title": "動物 Clicker，市集限定",
     "og_description": "自揀角色同顏色，可加字母珠。暫時只喺市集發售，未開放網上預訂。"
    },
    "en": {
     "title": "Animal Clicker, Markets Only | nomari studio",
     "description": "Build your own animal clicker: base size, character, colour, optional letter beads. Market only, not online yet.",
     "og_title": "Animal Clicker, market only",
     "og_description": "Choose the base, character and colour, add letter beads. Sold at markets for now, not online."
    }
   },
   "cross-stitch": {
    "zh": {
     "title": "隨身繡匙扣 | nomari studio",
     "description": "手工十字繡匙扣，細小可掛袋或鑰匙。款式同顏色可在備註寫低。可於網上預訂。",
     "og_title": "隨身繡匙扣",
     "og_description": "一針一線手工十字繡，可掛袋或鑰匙。款式同顏色備註即可，網上預訂。"
    },
    "en": {
     "title": "Pocket Stitch Keychain | nomari studio",
     "description": "A handmade cross-stitch keychain for a bag or keys. Note the design and colours you want. Pre-order online.",
     "og_title": "Pocket Stitch keychain",
     "og_description": "Hand-stitched, small enough for a bag or keys. Note the design and colours, then pre-order."
    }
   },
   "crochet": {
    "zh": {
     "title": "鈎織與訂製手工 | nomari studio",
     "description": "標準鈎織款可網上預訂。完全訂製請 IG DM @nomari.studio，落單後會再聯絡你。",
     "og_title": "鈎織與訂製手工",
     "og_description": "標準款網上預訂。想完全訂製，IG DM @nomari.studio。"
    },
    "en": {
     "title": "Crochet & Custom Handmade | nomari studio",
     "description": "Standard crochet pieces can be pre-ordered online. For a fully custom piece, DM @nomari.studio on Instagram.",
     "og_title": "Crochet & custom handmade",
     "og_description": "Pre-order standard pieces online. Fully custom work: Instagram DM @nomari.studio."
    }
   },
   "hk-nostalgia": {
    "zh": {
     "title": "香港懷舊小夜燈同匙扣 | nomari studio",
     "description": "香港街頭懷舊小夜燈同匙扣：安全島燈、紅A燈、舊式信箱、的士燈匙扣，另有匙扣組合。網上預訂，天車站交收或郵寄。",
     "og_title": "HK 懷舊：小夜燈同匙扣",
     "og_description": "安全島燈、的士燈匙扣等香港街頭懷舊小物，而家開放預訂。"
    },
    "en": {
     "title": "HK Nostalgia Lights & Keychains | nomari studio",
     "description": "Hong Kong nostalgia desk lights and keychains: Morrison signal light, Red A lamp, vintage mailbox and taxi lamp keychain, plus bundles. Pre-order online; SkyTrain pickup or shipping.",
     "og_title": "HK Nostalgia lights & keychains",
     "og_description": "The Morrison signal light, taxi lamp keychain and more Hong Kong street icons, now open for pre-order."
    }
   }
  };
  /*SEO-DATA-END*/
  window.NOMARI_SEO = DATA;
  function lang(){ return window.NomariI18n ? window.NomariI18n.current() : (document.documentElement.lang === "en" ? "en" : "zh-HK"); }
  function shown(id){ var e = document.getElementById(id); return !!(e && !e.hidden && !e.closest("[hidden]")); }
  function visibleProduct(id){ var C = window.NOMARI_CONFIG; return !!(id && DATA[id] && C && C.products.some(function(p){ return p.id === id; })); }
  // current view → {key: JSON key or null, path: query string of the canonical main-app URL}
  function view(){
    var q = new URLSearchParams(location.search), p = q.get("p");
    if (shown("productPage") && visibleProduct(p)) return {key: p, path: "?p=" + encodeURIComponent(p)};
    if (shown("viewCustom")) return {key: "custom", path: "?view=custom"};
    if (shown("catalogView")) return {key: "shop", path: "?view=shop"};
    if (shown("infoView")) return {key: null, path: "?view=info"};
    if (shown("checkoutView") || shown("done")) return {key: null, path: ""};
    return {key: "home", path: ""};
  }
  // default language is English (2026-10-03 14:40 PT): bare URL = en, zh-HK adds lang=zh-HK
  function url(path, l){ return ORIGIN + (l === "zh-HK" ? (path ? path + "&lang=zh-HK" : "?lang=zh-HK") : path); }
  function meta(attr, name, value){
    var el = document.head.querySelector("meta[" + attr + '="' + name + '"]');
    if (!el){ el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
    if (el.getAttribute("content") !== value) el.setAttribute("content", value);
  }
  function link(rel, href, hreflang){
    var sel = 'link[rel="' + rel + '"]' + (hreflang ? '[hreflang="' + hreflang + '"]' : ""), el = document.head.querySelector(sel);
    if (!el){ el = document.createElement("link"); el.rel = rel; if (hreflang) el.hreflang = hreflang; document.head.appendChild(el); }
    if (el.getAttribute("href") !== href) el.setAttribute("href", href);
  }
  var busy = false;
  function sync(){
    if (busy) return; busy = true;
    try {
      var l = lang(), k = l === "en" ? "en" : "zh", v = view(), d = (DATA[v.key || "home"] || {})[k];
      if (!d) return;
      if (v.key && document.title !== d.title) document.title = d.title;   // views without own copy keep the app title
      var title = v.key ? d.title : document.title;
      meta("name", "description", d.description);
      meta("property", "og:title", v.key ? d.og_title : title);
      meta("property", "og:description", d.og_description);
      meta("property", "og:url", url(v.path, l));
      meta("name", "twitter:title", v.key ? d.og_title : title);
      meta("name", "twitter:description", d.og_description);
      meta("property", "og:locale", l === "en" ? "en_CA" : "zh_HK");
      link("canonical", url(v.path, l));
      link("alternate", url(v.path, "zh-HK"), "zh-HK");
      link("alternate", url(v.path, "en"), "en");
      link("alternate", url(v.path, "en"), "x-default");
    } finally { busy = false; }
  }
  // app.js / i18n.js / custom.js set document.title on every view or language change → re-sync from the JSON after each change
  function start(){
    var t = document.querySelector("title"); if (!t){ t = document.createElement("title"); document.head.appendChild(t); }
    new MutationObserver(function(){ if (!busy) sync(); }).observe(t, {childList: true, characterData: true, subtree: true});
    window.addEventListener("popstate", function(){ setTimeout(sync, 0); });
    sync();
  }
  window.NomariSEO = {sync: sync, view: view, url: url, data: DATA};
  if (document.readyState !== "complete") document.addEventListener("DOMContentLoaded", start); else start();   // after app.js has rendered
})();
